<template>
  <div>
    <div class="news-page page">
      <!-- 顶部1 -->
      <page-top></page-top>
      <!-- 头部 -->
      <Header></Header>
      <!-- 主体 -->
      <main class="main">
        <section class="breadcrumb-plate w">
          <div class="label">当前位置：</div>
          <breadcrumb />
        </section>
        <section class="content w">
          <div class="c-left">
            <tabbar :tabData="tabList" :code="categoryId"></tabbar>
          </div>
          <div class="c-right">
            <div class="professor-detail">
              <div class="name">{{ detail.teacherName }}</div>
              <img
                :src="
                  $globalHeader.fileUrl + detail.avatarUrl + detail.avatarName
                "
              />

              <div class="article-content">职称：{{ detail.education }}</div>
              <div class="article-content" v-html="detail.description"></div>
            </div>
          </div>
        </section>
      </main>
      <!-- 底部 -->
      <Footer></Footer>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import Tabbar from "@/components/list/tabbar.vue";

import Breadcrumb from "@/components/common/breadcrumb";
import { getProfessorDetail } from "@/api/professor/index";

export default {
  components: { pageTop, Header, Footer, Tabbar, Breadcrumb },
  data() {
    return {
      tabList: {
        categoryCode: "1002",
        categoryName: "专家顾问",
      },
      tabTitle: "新闻中心",
      newsList: [],
      detail: "",
      categoryId: "1002",
    };
  },
  created() {
    let id = this.$route.params.id;
    this.professorDetail(id);
  },
  methods: {
    professorDetail(id) {
      getProfessorDetail(id).then((res) => {
        if (!res.data) return;
        this.detail = res.data;
        this.detail.description = " 个人简介：" + res.data.description;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.news-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #f1f1f1;

    .breadcrumb-plate {
      display: flex;
      align-items: center;
      padding: 16px 0;

      .label {
        line-height: 1;
        font-size: 14px;
      }

      .el-breadcrumb {
        cursor: pointer;

        /deep/ .el-breadcrumb__inner.is-link {
          font-weight: normal;
        }
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      .c-left {
        width: 270px;
        flex-shrink: 0;

        margin-right: 15px;
        background-color: #fff;
        // box-shadow: 0 2px 2px rgba($color: #000000, $alpha: 0.05);
        box-shadow: 0px 2px 2px #edeef0;
      }

      .c-right {
        flex: 1;
        box-shadow: 0px 2px 2px #edeef0;
        background-color: #fff;
        .professor-detail {
          display: flex;
          flex-direction: column;
          padding: 20px 20px 50px;

          .name {
            font-weight: bold;
            font-size: 20px;
            padding-bottom: 10px;
            border-bottom: 1px dashed #000;
          }

          img {
            margin-top: 50px;
            width: 420px;
            height: 300px;
          }

          .article-content {
            padding-top: 10px;
            line-height: 32px;
            font-size: 15px;
          }
          .article-content:last-child {
            padding-bottom: 50px;
            border-bottom: 1px dashed #000;
          }
        }
        .m-bot {
          margin-top: 24px;
          margin-bottom: 24px;

          .el-pagination {
            display: flex;
            justify-content: center;

            /deep/ .btn-prev {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-prev:hover:enabled {
              color: #409eff;
            }

            /deep/ .number {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .more {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next:hover:enabled {
              color: #409eff;
            }

            /deep/ .active {
              color: #fff;
              background-color: #409eff;
            }
          }
        }
      }
    }
  }
}
</style>
